import { useForm } from 'react-hook-form'
import { z } from 'zod'
import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form'
import { Input } from '@/components/ui/input'
import { useAuth } from '@/hooks/useAuth'
import { toast } from 'sonner'
import { examinationRoomService } from '@/services/examination_service'

export const formSchema = z.object({
  name: z.string().min(1, { message: '請輸入診間名稱' }),
  department: z.string().min(1, { message: '請輸入科別' }),
})

interface ExaminationRoomCreateDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  clinicId: number
  onSuccess?: () => void
}

export function ExaminationRoomCreateDialog({
  open,
  onOpenChange,
  clinicId,
  onSuccess,
}: ExaminationRoomCreateDialogProps) {
  const { token } = useAuth()

  const form = useForm<z.infer<typeof formSchema>>({
    // resolver: zodResolver(formSchema),
    defaultValues: {
      name: '',
      department: '',
    },
  })

  const onSubmit = async (values: z.infer<typeof formSchema>) => {
    if (!token) return

    const result = await examinationRoomService.createExaminationRoom(
      {
        clinic_id: clinicId,
        name: values.name,
        department: values.department,
      },
      token,
    )

    if (result.success) {
      toast.success('新增診間成功')
      form.reset()
      onSuccess?.()
      onOpenChange(false)
    } else {
      toast.error('新增診間失敗')
    }
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>新增診間</DialogTitle>
          <DialogDescription>新增診間至診所</DialogDescription>
        </DialogHeader>
        <Form {...form}>
          <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-4">
            <FormField
              control={form.control}
              name="name"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>診間名稱</FormLabel>
                  <FormControl>
                    <Input placeholder="請輸入診間名稱" {...field} />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
            <FormField
              control={form.control}
              name="department"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>科別</FormLabel>
                  <FormControl>
                    <Input placeholder="請輸入科別" {...field} />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
            <DialogFooter>
              <Button type="submit">新增</Button>
            </DialogFooter>
          </form>
        </Form>
      </DialogContent>
    </Dialog>
  )
}
